import React, { Children } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';

export default function AgencyInfoGrid({ children }) {
  const items = Children.toArray(children);

  return (
    (<Grid container spacing={0}>
      <Grid size={12}>{items[0]}</Grid>
      <Grid container spacing={3}>
        <Grid size={6}>{items[1]}</Grid>
        <Grid size={6}>{items[2]}</Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid size={6}>{items[3]}</Grid>
        <Grid size={6}>{items[4]}</Grid>
      </Grid>
      <Grid size={12}>{items[5]}</Grid>
      <Grid size={12}>{items[6]}</Grid>
    </Grid>)
  );
}

AgencyInfoGrid.propTypes = {
  children: PropTypes.node,
};
